import clsx from "clsx";
import React, { useState } from "react";
import { DropdownChoicesType, DropdownChoiceType } from "../types/common";
import { eventSelectType } from "../../common/types/common";

interface SelectProps {
	children?: React.ReactNode;
	choices?: DropdownChoicesType;
	currentValue?: string | number;
	disabled?: boolean;
	emptyValue?: string;
	onInputChange: (name: string, value: string) => void;
	name: string;
	required?: boolean;
}

export default function Select({
	children,
	choices,
	currentValue,
	disabled = false,
	emptyValue,
	onInputChange,
	name,
	required = false,
}: SelectProps) {
	const [checked, setChecked] = useState(false);

	const handleChange = (e: eventSelectType) => {
		const value = e.target.value;
		setChecked(!!value);
		onInputChange(name, value);
	};

	let options = children;

	if (choices) {
		options = choices.map((choice: DropdownChoiceType) => (
			<option key={choice.key} value={choice.key}>
				{choice.value}
			</option>
		));
	}

	return (
		<select
			className={clsx("form-select", { checked })}
			disabled={disabled}
			id={name}
			name={name}
			value={currentValue}
			onChange={handleChange}
			required={required}
		>
			{emptyValue && (
				<option key="" value="" disabled={required} hidden={required}>
					{emptyValue}
				</option>
			)}
			{options}
		</select>
	);
}
